<template>
  <p v-html="displayValue"></p>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "DaysRemaining",
  computed: {
    displayValue() {
      function isDate(s) {
        if (isNaN(s) && !isNaN(Date.parse(s))) return true;
        else return false;
      }

      if (isDate(this.params.value) || this.params.value instanceof Date) {
        const targetDate = new Date(this.params.value);
        const today = new Date();
        const timeDiff = targetDate - today;
        const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        if (daysDiff < 0) {
          return `${Math.abs(daysDiff)} over`;
        } else {
          return `${daysDiff}`;
        }
      } else {
        return this.params.value;
      }
    },
  },
});
</script>
